import { machineTechnicianUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default (showing = true) => {
  machineTechnicianUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
